import { useCallback } from 'react';
import useAxios from '@Apis/useAxios';
import {
    GET_MEMBER_REWARD,
    GET_MEMBER_REWARD_REDEEM_CART,
    POST_MEMBER_REWARD_REDEEM_CART,
    POST_MEMBER_REWARD_UN_REDEEM,
    GET_MEMBER_REWARD_RECORDS,
} from '@Apis/apiPath';

const useMemberRedeemApi = () => {
    const Axios = useAxios();

    // 取得本人點數主檔（currentPoints、expiryDate）
    const getRewardApi = useCallback(async () => {
        return await Axios.get(GET_MEMBER_REWARD);
        // eslint-disable-next-line
    }, []);

    // 取得當期兌換商品清單 + 本人已選結果 + canRedeem
    const getRedeemCartApi = useCallback(async () => {
        return await Axios.get(GET_MEMBER_REWARD_REDEEM_CART);
        // eslint-disable-next-line
    }, []);

    // 送出兌換（data: { redeemResults: [{ itemID, quantity }] }）
    const postRedeemCartApi = useCallback(async (data) => {
        return await Axios.post(POST_MEMBER_REWARD_REDEEM_CART, data);
        // eslint-disable-next-line
    }, []);

    // 本次不兌換（後端依登入會員與當期活動處理，無需 body）
    const postUnRedeemApi = useCallback(async () => {
        return await Axios.post(POST_MEMBER_REWARD_UN_REDEEM);
        // eslint-disable-next-line
    }, []);

    // 兌換紀錄（分頁）
    const getRedeemRecordsApi = useCallback(async (params) => {
        return await Axios.get(GET_MEMBER_REWARD_RECORDS, params);
        // eslint-disable-next-line
    }, []);

    return { getRewardApi, getRedeemCartApi, postRedeemCartApi, postUnRedeemApi, getRedeemRecordsApi };
};

export default useMemberRedeemApi;
